module.exports = __webpack_public_path__ + "img/proof.a0124e9a.svg";